import { render, staticRenderFns } from "./GeneAssociationsMasks.vue?vue&type=template&id=4d81c900&"
import script from "./GeneAssociationsMasks.vue?vue&type=script&lang=js&"
export * from "./GeneAssociationsMasks.vue?vue&type=script&lang=js&"
import style0 from "./GeneAssociationsMasks.vue?vue&type=style&index=0&id=4d81c900&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d81c900')) {
      api.createRecord('4d81c900', component.options)
    } else {
      api.reload('4d81c900', component.options)
    }
    module.hot.accept("./GeneAssociationsMasks.vue?vue&type=template&id=4d81c900&", function () {
      api.rerender('4d81c900', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GeneAssociationsMasks.vue"
export default component.exports